@if (authService.adminLevelAccess) {
  <div class="main-container">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      class="header-container"
      fxLayoutAlign="space-between stretch"
    >
      <h2>
        <span class="title">{{ title }}</span>
      </h2>
      <button
        tabindex="1"
        mat-icon-button
        class="close-button"
        aria-label="Close Panel"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="content-container">
      <app-compose-email
        [emailType]="emailType"
        [recipientPersonId]="recipientPersonId"
        (composedEmailForm)="onComposeEmailComplete($event)"
      >
      </app-compose-email>
    </div>
    <div>
      <span class="content-container"
        >Send email to {{ fullName }} ({{ email }})</span
      >
    </div>
    <div class="email-buttons" fxLayout fxLayoutGap="10px">
      <button
        mat-flat-button
        color="primary"
        [disabled]="!isValid"
        (click)="onSend()"
      >
        Send email now
      </button>
      <button
        mat-stroked-button
        class="mat-secondary-button"
        (click)="onClose()"
      >
        Cancel
      </button>
    </div>
  </div>
}
